import { useLocation } from 'react-router-dom';

const useScreenKey = (): string => {
  const location = useLocation();

  const path = location.pathname.slice(1);

  if (path === '') {
    return 'splash';
  }

  if (path === 'feedback') {
    return 'feedback';
  }

  if (path.startsWith('watch-plans') || path.startsWith('plan-video')) {
    return 'watch-plan';
  }

  return 'main';
};

export default useScreenKey;
